module.exports = __webpack_public_path__ + "img/Menu-09.a06db1a0.png";